<template>
    <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                {{Core.Definition.getDefinition('Contrat')}}
            </div>

            <b-row v-if="dataStatus === Mantle.Contract.statusPublish">
                <b-col>
                    <DynamicForm
                            v-model="dataId"
                            ref="dynamicForm"
                            getRoot="/contract"
                            saveRoot="/contract"
                            @onTrashClick="onTrashClick"
                            @onSaveSuccess="onSaveSuccess"
                            @onRequestSuccess="onRequestSuccess"
                            :formStructure="dataFormStructures.contract">
                        <slot slot="beforeFormButtons">
                            <b-button v-if="false" variant="light">{{Core.Definition.getDefinition('Aperçu')}}</b-button>
                        </slot>
                        <slot slot="bottomForm">
                            <b-row v-if="Core.Validation.isId(dataId)" class="mt-2">
                                <b-col class="text-right">
                                    <hr/>
                                    <b-button-group class="mr-2">
                                        <b-input v-model="dataSend.recipient" :placeholder="Core.Definition.getDefinition('Destinataire')" type="text"></b-input>
                                        <b-button :disabled="dataSend.processing" @click="onSendClick" variant="success">{{Core.Definition.getDefinition('Envoyer')}}</b-button>
                                    </b-button-group>
                                    <br/>
                                    <small class="text-muted">
                                        {{Core.Definition.getDefinition('Le destinataire recevera un lien pour compléter le formulaire et approuver le contrat. Vous ne pourrez plus modifier le contrat.')}}
                                    </small>
                                </b-col>
                            </b-row>
                        </slot>

                    </DynamicForm>
                </b-col>
            </b-row>

            <div v-if="dataStatus !== Mantle.Contract.statusPublish">

                <b-row>
                    <b-col lg="9">
                        <div v-html="dataPreview"></div>
                    </b-col>
                    <b-col lg="3">

                        <b-list-group>
                            <b-list-group-item>
                                <small>{{dataForm.sendDate}}</small><br/>
                                {{Core.Text.format(Core.Definition.getDefinition('La demande d\'approbation est envoyée à {0}'), dataForm.sendEmail)}}</b-list-group-item>
                            <b-list-group-item v-if="dataForm.status === Mantle.Contract.statusAccepted">
                                <small>{{dataForm.approvedDate}}</small><br/>
                                {{Core.Definition.getDefinition('Le contrat est accepté')}}
                            </b-list-group-item>
                            <b-list-group-item v-if="dataForm.status === Mantle.Contract.statusRefused">
                                <small>{{dataForm.refusedDate}}</small><br/>
                                {{Core.Definition.getDefinition('Le contrat est refusé')}}
                            </b-list-group-item>
                        </b-list-group>

                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col class="text-right">
                        <hr/>
                        <b-button-group class="mr-2">
                            <b-input v-model="dataSend.recipient" :placeholder="Core.Definition.getDefinition('Destinataire')" type="text"></b-input>
                            <b-button :disabled="dataSend.processing" @click="onSendClick" variant="success">{{Core.Definition.getDefinition('Envoyer')}}</b-button>
                        </b-button-group>
                        <br/>
                        <small class="text-muted">
                            {{Core.Definition.getDefinition('Le destinataire recevera un lien pour compléter le formulaire et approuver le contrat. Vous ne pourrez plus modifier le contrat.')}}
                        </small>
                    </b-col>
                </b-row>
            </div>

        </b-card>

        <ModalTrash
                ref="trash"
                root="/address"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du contrat')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce contrat?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import Request from '../../components/Request'
    export default {
        name: 'Contract',
        components: {
            DynamicForm,
            ModalTrash,
            Request
        },
        mounted() {
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                Mantle: window.Mantle,
                dataId: '',
                dataSend: {
                    recipient: '',
                    processing: false
                },
                dataStatus: Mantle.Contract.statusPublish,
                dataForm: {},
                dataPreview: '',
                dataFormStructures: {
                    contract: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'userId'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'purchaseLink'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'formTemplateId'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'content'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'formTemplateId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Modèle de contrat'),
                                value: null,
                                onSelect: function() {},
                                required: false
                            },
                            {
                                id: 'userId',
                                type: 'instanceSelector',
                                label: Core.Definition.getDefinition('Associer à un utilisateur'),
                                value: {
                                    id: '',
                                    label: ''
                                },
                                emptyMessage: Core.Definition.getDefinition('Aucun utilisateur sélectionné'),
                                instanceSelector: {
                                    label: [
                                        'firstname',
                                        'lastname'
                                    ],
                                    id: 'id',
                                    root: '/user/list',
                                    searchFormStructure: {
                                        rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'firstname'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'lastname'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'email'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'phone'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'id'
                                                            }
                                                        ]
                                                    },
                                                    {}
                                                ]
                                            }
                                        ],
                                        fields: [
                                            {
                                                id: 'id',
                                                type: 'number',
                                                label: Core.Definition.getDefinition('ID'),
                                                value: ''
                                            },
                                            {
                                                id: 'firstname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Prénom'),
                                                value: ''
                                            },
                                            {
                                                id: 'lastname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Nom de famille'),
                                                value: ''
                                            },
                                            {
                                                id: 'phone',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Téléphone'),
                                                value: ''
                                            },
                                            {
                                                id: 'email',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Courriel'),
                                                value: ''
                                            }
                                        ]
                                    },
                                    options: {
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucun utilisateur à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                    },
                                    columns: [
                                        {
                                            label: Core.Definition.getDefinition('#'),
                                            key: 'id',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Prénom'),
                                            key: 'firstname',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Nom'),
                                            key: 'lastname',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Courriel'),
                                            key: 'email',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Téléphone'),
                                            key: 'phone',
                                            sortable: true
                                        }
                                    ]
                                }
                            },
                            {
                                id: 'purchaseLink',
                                type: 'instanceSelector',
                                label: Core.Definition.getDefinition('Associer à un achat'),
                                value: {
                                    id: '',
                                    label: ''
                                },
                                emptyMessage: Core.Definition.getDefinition('Aucun achat sélectionné'),
                                instanceSelector: {
                                    label: [
                                        'purchaseTypeLabel',
                                        'purchaseId'
                                    ],
                                    id: ['purchaseId', 'purchaseType'],
                                    root: '/commerce/purchases',
                                    searchFormStructure: {
                                        rows: [
                                            {
                                                cols: [
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'userFirstname'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'userLastname'
                                                            }
                                                        ]
                                                    },
                                                ]
                                            },
                                            {
                                                cols: [

                                                    {
                                                        fields: [
                                                            {
                                                                id: 'userEmail'
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        fields: [
                                                            {
                                                                id: 'userPhone'
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        fields: [
                                            {
                                                id: 'userFirstname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Prénom'),
                                                value: ''
                                            },
                                            {
                                                id: 'userLastname',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Nom de famille'),
                                                value: ''
                                            },
                                            {
                                                id: 'userPhone',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Téléphone'),
                                                value: ''
                                            },
                                            {
                                                id: 'userEmail',
                                                type: 'text',
                                                label: Core.Definition.getDefinition('Courriel'),
                                                value: ''
                                            }
                                        ]
                                    },
                                    options: {
                                        pagination: true,
                                        header: true,
                                        responsive: false,
                                        striped: true,
                                        headerStyle: '1',
                                        emptyText: Core.Definition.getDefinition('Aucun achat à afficher'),
                                        borderVariant: 'white',
                                        noBody: true
                                    },
                                    columns: [
                                        {
                                            label: Core.Definition.getDefinition('ID achat'),
                                            key: 'purchaseId',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Type achat'),
                                            key: 'purchaseTypeLabel',
                                            type: 'text',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Prénom'),
                                            key: 'userFirstname',
                                            type: 'text',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Nom de famille'),
                                            key: 'userLastname',
                                            type: 'text',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Produit'),
                                            key: 'productTitle',
                                            type: 'text',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Date de création'),
                                            key: 'creationDate',
                                            type: 'date',
                                            sortable: true
                                        }
                                    ]
                                }
                            },
                            {
                                id: 'content',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Notes supplémentaires'),
                                value: '',
                                required: false
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/commerce/contrats')
            },
            onSendClick() {
                if (this.dataSend.recipient !== '') {
                    this.$refs.dynamicForm.addSaveArg('send', '1')
                    this.$refs.dynamicForm.addSaveArg('recipient', this.dataSend.recipient)
                    this.$refs.dynamicForm.$refs.form.submit()
                }
            },
            onRequestSuccess(data) {
                if (data.form !== undefined) {
                    this.dataForm = data.form
                    if (data.form.status !== undefined) {
                        this.dataStatus = data.form.status
                    }
                }
                if (data.status !== undefined) {
                    this.dataStatus = data.status
                }
                if (data.preview !== undefined) {
                    this.dataPreview = data.preview
                }
            },
            onSaveSuccess(data) {
                this.$refs.dynamicForm.addSaveArg('send', '0')
                this.$refs.dynamicForm.addSaveArg('recipient', '')
            }
        }
    }
</script>
